import React, {Component, PropTypes} from 'react';

export default class Highlight extends Component {
    static propTypes = {
        value: PropTypes.string.isRequired,
        range: PropTypes.arrayOf(PropTypes.number),
        className: PropTypes.string,
        onClick: PropTypes.func,
    };

    static defaultProps = {
        range: [],
        className: null,
        onClick: null,
    };

    shouldComponentUpdate(nextProps) {
        return nextProps.value !== this.props.value
            || nextProps.range[0] !== this.props.range[0]
            || nextProps.range[1] !== this.props.range[1]
            || nextProps.className !== this.props.className
            || nextProps.onClick !== this.props.onClick;
    }

    render() {
        const {value, range, className, onClick} = this.props;
        const [start, length] = range;
        const attrs = {className, onClick};

        if (!length) return <span {...attrs}>{value}</span>;

        return (
            <span {...attrs}>
                {start > 0 && value.substr(0, start)}
                <span className='cielo24-vwrap-highlight'>{value.substr(start, length)}</span>
                {length < value.length && value.substr(start + length)}
            </span>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/utils/highlight.js